import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from 'react-icons/fa';
import api from '../services/api';


const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [validated, setValidated] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        setValidated(true);
        setIsLoading(true);
        setShowError(false);
        setErrorMessage('');

        try {
            const response = await api.post('/contact/send', formData);


            if (response.data && response.data.success) {
                console.log('Mesaj başarıyla gönderildi:', response.data);
                setShowSuccess(true);
                setFormData({ name: '', email: '', phone: '', message: '' });
                setValidated(false);
            } else {
                setShowError(true);
                setErrorMessage(response.data?.message || 'Mesaj gönderilirken bir hata oluştu.');
            }
        } catch (error) {
            console.error('Mesaj gönderme hatası:', error);
            setShowError(true);
            setErrorMessage(
                error.response?.data?.message ||
                'Mesaj işlenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.'
            );
        } finally {
            setIsLoading(false);

            if (showSuccess) {
                setTimeout(() => {
                    setShowSuccess(false);
                }, 5000);
            }
        }
    };

    return (
        <div className="contact-page">
            {/* Header Section - Elegant */}
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <h1 className="section-title">İLETİŞİM</h1>
                        <p className="lead">Bizimle iletişime geçin, sorularınızı yanıtlayalım.</p>
                    </div>
                </Container>
            </section>

            {/* Contact Info Cards - Using modern-advantage-card */}
            <section className="modern-advantages-section py-5 bg-light">
                <Container>
                    <Row className="g-4">
                        <Col lg={3} md={6}>
                            <div className="modern-advantage-card text-center">
                                <div className="advantage-icon-modern">
                                    <FaMapMarkerAlt />
                                </div>
                                <div className="advantage-content">
                                    <h5 className="advantage-title-modern">Adres</h5>
                                    <p className="advantage-description-modern">
                                        Kaynarca Mah. Zirve Sok., Optimum Modern Sitesi No:1, 34890 Pendik/İstanbul
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={3} md={6}>
                            <div className="modern-advantage-card text-center">
                                <div className="advantage-icon-modern">
                                    <FaPhoneAlt />
                                </div>
                                <div className="advantage-content">
                                    <h5 className="advantage-title-modern">Telefon</h5>
                                    <p className="advantage-description-modern">
                                        +90 (532) 387 30 91
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={3} md={6}>
                            <div className="modern-advantage-card text-center">
                                <div className="advantage-icon-modern">
                                    <FaEnvelope />
                                </div>
                                <div className="advantage-content">
                                    <h5 className="advantage-title-modern">E-posta</h5>
                                    <p className="advantage-description-modern">
                                        otoprime34@gmail.com
                                    </p>
                                </div>
                            </div>
                        </Col>

                        <Col lg={3} md={6}>
                            <div className="modern-advantage-card text-center">
                                <div className="advantage-icon-modern">
                                    <FaClock />
                                </div>
                                <div className="advantage-content">
                                    <h5 className="advantage-title-modern">Çalışma Saatleri</h5>
                                    <p className="advantage-description-modern">
                                        Pazartesi - Cumartesi: 09:00 - 18:00<br />
                                        Pazar: Kapalı
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Contact Form & Map Section */}
            <section className="py-5">
                <Container>
                    <Row className="g-5">
                        <Col lg={6}>
                            <div className="modern-faq-item">
                                <h3 className="modern-faq-question">Bize Mesaj Gönderin</h3>

                                {showSuccess && (
                                    <Alert variant="success" onClose={() => setShowSuccess(false)} dismissible>
                                        Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.
                                    </Alert>
                                )}

                                {showError && (
                                    <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
                                        {errorMessage || 'Mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin.'}
                                    </Alert>
                                )}

                                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="contactName">
                                        <Form.Label>Adınız Soyadınız</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen adınızı giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="contactEmail">
                                        <Form.Label>E-posta Adresiniz</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen geçerli bir e-posta adresi giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="contactPhone">
                                        <Form.Label>Telefon</Form.Label>
                                        <Form.Control
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen telefon numaranızı giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group className="mb-4" controlId="contactMessage">
                                        <Form.Label>Mesajınız</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Lütfen mesajınızı giriniz.
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Button
                                        type="submit"
                                        className="apply-btn-black w-100 py-3"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? (
                                            <>
                                                <Spinner
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                    className="me-2"
                                                />
                                                Gönderiliyor...
                                            </>
                                        ) : (
                                            "Mesajı Gönder"
                                        )}
                                    </Button>
                                </Form>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="modern-faq-item">
                                <h3 className="modern-faq-question">Bizi Ziyaret Edin</h3>
                                <div className="modern-faq-answer">
                                    <div
                                        className="google-map"
                                        style={{
                                            borderRadius: 'var(--radius-md)',
                                            overflow: 'hidden',
                                            boxShadow: 'var(--shadow)',
                                            border: '1px solid var(--gray-200)'
                                        }}
                                    >
                                        <iframe
                                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3014.7218240582106!2d29.240124115775256!3d40.92364867930942!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac5351c2bfa95%3A0x10daee34f31d2d25!2sKaynarca%2C%20Pendik%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1620565848175!5m2!1str!2str"
                                            width="100%"
                                            height="400"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                            title="Otoprime Konum"
                                        ></iframe>
                                    </div>
                                    <p className="mt-4 text-center">
                                        <strong>Kolayca Ulaşın:</strong><br />
                                        Pendik Merkez'e 5 dakika, E-5 ve TEM'e kolay erişim
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Quick Contact CTA */}
            <section className="modern-cta-section py-5">
                <Container className="text-center">
                    <div className="cta-content-modern">
                        <h2 className="cta-title-modern">Hızlı İletişim</h2>
                        <p className="cta-description-modern">
                            Acil durumlar için doğrudan arayın: <strong>+90 (532) 387 30 91</strong>
                        </p>
                        <a
                            href="tel:+905323873091"
                            className="apply-btn-black btn-lg"
                            style={{ textDecoration: 'none' }}
                        >
                            <FaPhoneAlt className="me-2" />
                            Hemen Ara
                        </a>
                    </div>
                </Container>
            </section>
        </div>
    );
};

export default Contact;